import * as React from 'react'
import Modal from '../../../ui/Modal'
import { ICreateBankAccountObj, IGoinZoneObject, IMap } from 'src/types'
import { Button, Popup } from '@mobiscroll/react-latest'
import UIMessages from 'src/utils/ui-messages'

export interface IRemoveAccountModalProps {
  bankAccounts: IMap<ICreateBankAccountObj>
  onClose: () => void
  onRemove: (bankAccountId: string) => void
}

interface IRemoveBankAccountModalState {
  isPending?: boolean
  error?: string
  newOption?: string
  popupOpen: boolean
}

class RemoveBankAccountModal extends React.Component<any, IRemoveBankAccountModalState> {
  constructor(props: IRemoveAccountModalProps) {
    super(props)
    this.state = {
      popupOpen: true
    }
  }

  public render() {
    const id = this.props.match.params.id
    const bankAccount: any = this.props.bankAccounts.filter((account: any) => account.id === id)[0]
    const { deleteAccount, deleteConfirmation, deleteFail, warning } = UIMessages.organization.bankAccount
    const { cancel, deleteLabel, ok } = UIMessages.common
    return (
      <Popup isOpen={this.state.popupOpen} width={400} onClose={() => this.setState({ popupOpen: false })}>
        <div className='p2'>
          {!bankAccount.default_for_currency && <p className='mt0 uppercase'>{deleteAccount}</p>}
          {bankAccount.default_for_currency && <p className='mt0 uppercase'>{warning}</p>}
          <div className='bb-shadow-grey' />

          {!bankAccount.default_for_currency && (
            <p>
              {deleteConfirmation}
              <strong>{` ${bankAccount ? bankAccount.account_holder_name : ''}?`}</strong>
            </p>
          )}

          {bankAccount.default_for_currency && <p>{deleteFail}</p>}

          <div className='flex justify-end mt2'>
            {bankAccount.default_for_currency && (
              <Button ariaLabel='Ok button' className='mbsc-success-btn' onClick={this.handleCancelClick}>
                {ok}
              </Button>
            )}
            {!bankAccount.default_for_currency && (
              <Button ariaLabel='Close button' className='mbsc-flat-btn' onClick={this.handleCancelClick}>
                {cancel}
              </Button>
            )}
            {!bankAccount.default_for_currency && (
              <Button ariaLabel='Remove button' className='mbsc-danger-btn' onClick={this.handleRemoveClick}>
                {deleteLabel}
              </Button>
            )}
          </div>
        </div>
      </Popup>
    )
  }

  private handleRemoveClick = () => {
    this.props.onRemove(this.props.match.params.id)
    this.props.onClose()
    this.setState({ popupOpen: false })
  }

  private handleCancelClick = () => {
    this.props.onClose()
    this.setState({ popupOpen: false })
  }
}

export default RemoveBankAccountModal



// WEBPACK FOOTER //
// ./src/components/organizations/create/bankaccount/RemoveBankAccountModal.tsx